import ActionTypes from '../constants/ActionTypes';

/* Actions */

export const createModel = (data) => ({
  type: ActionTypes.MODEL_CREATE,
  payload: {
    data,
  },
});

export const updateModel = (id, data) => ({
  type: ActionTypes.MODEL_UPDATE,
  payload: {
    id,
    data,
  },
});

export const deleteModel = (id) => ({
  type: ActionTypes.MODEL_DELETE,
  payload: {
    id,
  },
});

/* Events */

export const createModelRequested = (data) => ({
  type: ActionTypes.MODEL_CREATE_REQUESTED,
  payload: {
    data,
  },
});

export const createModelSucceeded = (model) => ({
  type: ActionTypes.MODEL_CREATE_SUCCEEDED,
  payload: {
    model,
  },
});

export const createModelFailed = (error) => ({
  type: ActionTypes.MODEL_CREATE_FAILED,
  payload: {
    error,
  },
});

export const createModelReceived = (model) => ({
  type: ActionTypes.MODEL_CREATE_RECEIVED,
  payload: {
    model,
  },
});

export const updateModelRequested = (id, data) => ({
  type: ActionTypes.MODEL_UPDATE_REQUESTED,
  payload: {
    id,
    data,
  },
});

export const updateModelSucceeded = (model) => ({
  type: ActionTypes.MODEL_UPDATE_SUCCEEDED,
  payload: {
    model,
  },
});

export const updateModelFailed = (id, error) => ({
  type: ActionTypes.MODEL_UPDATE_FAILED,
  payload: {
    id,
    error,
  },
});

export const updateModelReceived = (model) => ({
  type: ActionTypes.MODEL_UPDATE_RECEIVED,
  payload: {
    model,
  },
});

export const deleteModelRequested = (id) => ({
  type: ActionTypes.MODEL_DELETE_REQUESTED,
  payload: {
    id,
  },
});

export const deleteModelSucceeded = (model) => ({
  type: ActionTypes.MODEL_DELETE_SUCCEEDED,
  payload: {
    model,
  },
});

export const deleteModelFailed = (id, error) => ({
  type: ActionTypes.MODEL_DELETE_FAILED,
  payload: {
    id,
    error,
  },
});

export const deleteModelReceived = (model) => ({
  type: ActionTypes.MODEL_DELETE_RECEIVED,
  payload: {
    model,
  },
});
